export const isBracketOrderEnable = selectedProduct => {
  // Check if product exists and bracket orders setting is undefined (enabled by default)
  if (selectedProduct && selectedProduct.ui_config?.show_bracket_orders === undefined) {
    return true;
  }
  return false;
};

export const isReduceOnlyEnable = selectedProduct => {
  // Check all required conditions:
  // 1. Product exists
  if (!selectedProduct) {
    return false;
  }

  // 2. Product is not a spot or tracker type
  const isNonSpotType =
    selectedProduct.contract_type !== 'spot' &&
    selectedProduct.contract_type !== 'tracker';

  // 3. Bracket orders are explicitly disabled
  const bracketOrdersDisabled = selectedProduct.ui_config?.show_bracket_orders === false;

  // Only return true if all conditions are met
  if (isNonSpotType && bracketOrdersDisabled) {
    return true;
  }
  return false;
};
